<mat-card class="w-full">
  <mat-card-header>
    <div class="flex flex-row rounded-lg w-full" style="background-color:#5775a8; padding: 20px;">
      <span style="font-size: large; color: white;">
        Additional Complaints Associated with this Business
      </span>
    </div>
  </mat-card-header>

  <mat-card-content class="flex justify-center items-center w-full">

    <div class="flex flex-col w-full items-center">
      <div class="flex flex-col w-11/12" *ngIf="showList">

        <div class="flex flex-row w-full">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort #MatSort="matSort" class="w-full">

            <ng-container matColumnDef="complaintId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
              <td mat-cell *matCellDef="let item"><a (click)="rowClick(item)">{{item.complaintId}}</a></td>
            </ng-container>
            <ng-container matColumnDef="complaintDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Date</th>
              <td mat-cell *matCellDef="let item">
                {{item.complaintDate}}
              </td>
            </ng-container>
            <ng-container matColumnDef="complaintStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Status</th>
              <td mat-cell *matCellDef="let item">{{item.complaintStatus}}</td>
            </ng-container>
            <ng-container matColumnDef="correspondence">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>IRL Sent Date</th>
              <td mat-cell *matCellDef="let item"><span *ngFor="let list of item.correspondence">{{list.sentDate}} </span></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

          </table>
        </div>
      </div>

    </div>

  </mat-card-content>
</mat-card>